<template>
  <div>
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-row no-gutters class="ms-3">
          <v-col>
            <v-tabs v-model="tab" height="64" background-color="transparent">
              <v-tab>
                <v-card-title class="pa-0">
                  {{ $t("Coupons.available") }}
                </v-card-title>
              </v-tab>
              <v-tab>
                <v-card-title class="pa-0">
                  {{ $t("Coupons.used") }}
                </v-card-title>
              </v-tab>
              <v-tab>
                <v-card-title class="pa-0">
                  {{ $t("Coupons.loss") }}
                </v-card-title>
              </v-tab>
            </v-tabs>
          </v-col>
        </v-row>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-data-table
                :headers="headers"
                :items="coupons"
                :loading="loading"
                multi-sort
                disable-pagination
                hide-default-footer
              >
                <template v-slot:item.coupon.coupon_value="{ item }">
                  <span>{{ item.coupon.coupon_value }}</span><br /><span>{{ item.coupon.coupon_rule_str }}</span>
                </template>
                <template v-slot:item.coupon.created="{ item }">
                  {{ item.coupon.created | formatTime }}
                </template>
              </v-data-table>
            </v-tab-item>
            <v-tab-item>
              <v-data-table
                :headers="headers"
                :items="coupons"
                :loading="loading"
                multi-sort
                disable-pagination
                hide-default-footer
              >
                <template v-slot:item.coupon.coupon_value="{ item }">
                  <span>{{ item.coupon.coupon_value }}</span><br /><span>{{ item.coupon.coupon_rule_str }}</span>
                </template>
                <template v-slot:item.coupon.created="{ item }">
                  {{ item.coupon.created | formatTime }}
                </template>
              </v-data-table>
            </v-tab-item>
            <v-tab-item>
              <v-data-table
                :headers="headers"
                :items="coupons"
                :loading="loading"
                multi-sort
                disable-pagination
                hide-default-footer
              >
                <template v-slot:item.coupon.coupon_value="{ item }">
                  <span>{{ item.coupon.coupon_value }}</span><br /><span>{{ item.coupon.coupon_rule_str }}</span>
                </template>
                <template v-slot:item.coupon.created="{ item }">
                  {{ item.coupon.created | formatTime }}
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  color="primary"
                  block
                  @click="dialog = true"
                >
                  {{ $t("Coupons.getCoupons") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>
    </v-slide-x-transition>
    <DialogCoupons
      v-model="dialog"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import Coupons from "@/api/coupons";
import DialogCoupons from "./plugins/DialogCoupons"

export default {
  components: {
    Breadcrumbs,
    DialogCoupons
  },

  computed: {
    items: () => [
      {
        text: i18n.t("SettingNav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("App.coupons"),
        disabled: true,
        href: "/user",
      },
    ],
    headers() {
      let headers = [
        {
          text: i18n.t("Coupons.Fields.name"),
          align: "start",
          sortable: true,
          value: "coupon.name",
        },
        {
          text: i18n.t("Coupons.Fields.type"),
          align: "start",
          sortable: true,
          value: "coupon.type_str",
        },
        {
          text: i18n.t("Coupons.Fields.coupon_value"),
          align: "start",
          sortable: true,
          value: "coupon.coupon_value",
        },
        {
          text: i18n.t("Coupons.Fields.valid"),
          align: "start",
          sortable: true,
          value: "coupon.valid_str",
        },
        {
          text: i18n.t("Coupons.Fields.rule"),
          align: "start",
          sortable: true,
          value: "coupon.rule_content",
          width: 400,
        },
        {
          text: i18n.t("Coupons.Fields.memo"),
          align: "start",
          sortable: true,
          value: "coupon.memo",
        },
        {
          text: i18n.t("Coupons.Fields.created"),
          align: "start",
          sortable: true,
          value: "coupon.created"
        }
      ]
      return headers
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "accountUser"]),
  },


  data: () => ({
    tab: null,
    coupons: [],
    dialog: false,
  }),

  mounted() {
  },

  methods: {
    getShopCoupons() {
      Coupons.getShopCoupons({status: (this.tab + 1)}).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.coupons = response.data.data
          }
        }.bind(this)
      )
    },
  },

  watch: {
    tab: {
      handler() {
        this.coupons = [];
        this.getShopCoupons()
      }
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.getShopCoupons()
        }
      }
    }
  },
};
</script>